import React, { useState, useEffect } from 'react';
import { getToken } from '../utils/getToken';
import MarketTable from '../component/market/MarketTable';

const baseURL = process.env.REACT_APP_BASE_URL || 'https://api.quickcare.ng/admin';

const MarketingPage = () => {
    const myDate = new Date();
    const MAX_DATE = `${myDate.getFullYear()}-${myDate.getUTCMonth() + 1 > 10 ? myDate.getUTCMonth() : `0${myDate.getUTCMonth()+1}`}-${myDate.getDate() >= 10 ? myDate.getDate() : `0${myDate.getDate()}`}`;
    const MIN_DATE = `${myDate.getFullYear()}-${myDate.getUTCMonth() + 1 > 10 ? myDate.getUTCMonth() : `0${myDate.getUTCMonth()+1}`}-${'01'}`;

    const [period, setPeriod] = useState({
        start_date: MIN_DATE,
        end_date: MAX_DATE
    });
    
    const [country, setCountry] = useState('kenya');
    const [marketStats, setMarketStats] = useState({error: false, loading: true, data: {}});

    const handlePeriodChange = ({target:{name, value}}) => {
        setPeriod(prev => ({...prev, [name]:value}));
    };

    useEffect(() => {
        const fetchStats = async () => {
            const myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");

            const token = getToken();
            if (token) {
                myHeaders.append("Authorization", `Bearer ${token}`);
            } else {
                console.error('No token found');
                return;
            }

            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };

            setMarketStats(prev => ({...prev, error: false, loading: true}));
            try {
                const response = await fetch(`${baseURL}/marketing/marketer-stats?start_date=${period.start_date}&end_date=${period.end_date}&country=${country}`, requestOptions);
                const result = await response.json();
                const data = result?.data;
                setMarketStats({loading: false, error: false, data: data});
            } catch (error) {
                setMarketStats({loading: false, error: true, data: {}});
            }
        };

        fetchStats();
    }, [period, country]);

    return (
        <div className='w-full px-3 sm:px-4 lg:px-6 py-4 lg:py-6 bg-gradient-to-br from-gray-50 to-gray-100/50 min-h-screen mt-8 lg:mt-0'>
            {/* Page Header */}
            <div className='mb-6'>
                <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3'>
                    <div>
                        <h1 className='text-2xl lg:text-3xl font-bold text-gray-800 flex items-center gap-2'>
                            <span>📢</span> Marketing Dashboard
                        </h1>
                        <p className='text-sm text-gray-500 mt-1'>
                            Monitor your marketing partners and their performance
                        </p>
                    </div>
                    <div className='flex items-center gap-2 text-sm text-gray-500 bg-white px-4 py-2 rounded-xl shadow-sm'>
                        <span className='inline-block w-2 h-2 bg-green-500 rounded-full animate-pulse'></span>
                        Live Data
                    </div>
                </div>
            </div>

            {/* Filters Section */}
            <div className='bg-white rounded-2xl shadow-sm p-4 lg:p-6 mb-6 border border-gray-100 hover:shadow-md transition-shadow duration-300'>
                <div className='flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4'>
                    <div className='flex items-center gap-2'>
                        <div className='p-2 bg-[#069125]/10 rounded-xl'>
                            <span className='text-lg'>🔍</span>
                        </div>
                        <div>
                            <h2 className='text-lg font-semibold text-gray-700'>Filters</h2>
                            <p className='text-xs text-gray-400'>Customize your marketing view</p>
                        </div>
                    </div>
                    
                    <div className='flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3 sm:gap-4 w-full lg:w-auto'>
                        <div className='flex flex-col gap-1 w-full sm:w-auto'>
                            <label className='text-xs font-medium text-gray-600 uppercase tracking-wider flex items-center gap-1'>
                                <span>📅</span> Start Date
                            </label>
                            <input 
                                className="px-3 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-[#069125]/20 focus:border-[#069125] outline-none transition-all duration-200 w-full sm:w-40 hover:border-gray-300"
                                max={period.end_date}
                                name='start_date' 
                                value={period.start_date} 
                                type='date' 
                                onChange={handlePeriodChange} 
                            />
                        </div>

                        <div className='flex flex-col gap-1 w-full sm:w-auto'>
                            <label className='text-xs font-medium text-gray-600 uppercase tracking-wider flex items-center gap-1'>
                                <span>📅</span> End Date
                            </label>
                            <input 
                                className="px-3 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-[#069125]/20 focus:border-[#069125] outline-none transition-all duration-200 w-full sm:w-40 hover:border-gray-300"
                                min={period.start_date}
                                max={MAX_DATE}
                                name='end_date' 
                                value={period.end_date} 
                                type='date' 
                                onChange={handlePeriodChange} 
                            />
                        </div>

                        <div className='flex flex-col gap-1 w-full sm:w-auto'>
                            <label className='text-xs font-medium text-gray-600 uppercase tracking-wider flex items-center gap-1'>
                                <span>🌍</span> Country
                            </label>
                            <select 
                                id="country" 
                                value={country} 
                                onChange={(e) => setCountry(e.target.value)}
                                className='px-3 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-[#069125]/20 focus:border-[#069125] outline-none transition-all duration-200 w-full sm:w-36 hover:border-gray-300 cursor-pointer'
                            >
                                <option value="kenya">🇰🇪 Kenya</option>
                                <option value="nigeria">🇳🇬 Nigeria</option>
                            </select>
                        </div>

                        <button 
                            onClick={() => {}} 
                            className='mt-4 sm:mt-6 px-6 py-2.5 bg-[#069125] text-white text-sm font-semibold rounded-xl hover:bg-[#057a1f] transition-all duration-200 hover:shadow-lg hover:shadow-[#069125]/30 w-full sm:w-auto'
                        >
                            Apply Filters
                        </button>
                    </div>
                </div>
            </div>

            {/* Market Table Component */}
            <MarketTable tableData={marketStats} />
        </div>
    );
};

export default MarketingPage;